import React, { useEffect, useState } from "react";

export interface IPropsNavigation {
    navigation?: React.RefObject<HTMLDivElement> | null;
}
export const useNavigatorScroll = ({ navigation }: IPropsNavigation) => {
    const [scrolling, setScrolling] = useState(false);
    const [scrollTop, setScrollTop] = useState(0);

    useEffect(() => {
        function onNavigation() {
            if (!navigation?.current) return;

            if (navigation.current.scrollTop > 200) {
                setScrolling(true);
            } else {
                setScrolling(false);
            }
            setScrollTop(navigation.current.scrollTop);
        }

        navigation?.current?.addEventListener('scroll', onNavigation)
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            navigation?.current?.removeEventListener('scroll', onNavigation)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        scrolling,
        scrollTop
    }

}